module.exports = __webpack_public_path__ + "img/titletow.cdbb6332.png";